import { AbsencePopoverBar } from "~/modules/dashboard/components/TimeTrackingCalendar/AbsencePopoverBar.tsx";
import { AbsenceRow } from "~/modules/dashboard/components/TimeTrackingCalendar/AbsenceRow.tsx";
import type { CalendarAbsenceActions, CalendarDay } from "~/modules/dashboard/components/TimeTrackingCalendar/calendarDays.ts";
import TimeTrackingBar from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/TimeTrackingBar";

type Props = {
	day: CalendarDay;
	absenceActions?: CalendarAbsenceActions;
	size?: "sm";
	hideHoliday?: boolean;
	/** An absence opens in place, as in the day view, not in a popover. */
	inPlace?: boolean;
};

/** The holiday and the absences of a day, as the bars that the month grid and the day list share. */
export function HolidayAndAbsenceBars({ day, absenceActions, size, hideHoliday, inPlace }: Props) {
	return (
		<>
			{day.holiday && !hideHoliday && <TimeTrackingBar size={size}>{day.holiday.displayName}</TimeTrackingBar>}
			{day.absences.map(({ absence, absenceName }, index) => absenceActions ? (
				<AbsencePopoverBar key={index}
								   absence={absence}
								   absenceName={absenceName}
								   absenceActions={absenceActions}
								   size={size}
								   inPlace={inPlace} />
			) : (
				<AbsenceRow key={index}
							 absenceName={absenceName}
							 size={size} />
			))}
		</>
	);
}
